import React from 'react';

import PropTypes from 'prop-types';

import {
  avatarBadge
} from './style.jsx';

const propTypes = {
  additionalClassName: PropTypes.string,
  ariaProps: PropTypes.object,
  userName: PropTypes.string
};

/* eslint-disable jsx-a11y/anchor-has-content */
const UserAvatar = React.forwardRef((props, ref) => {
  UserAvatar.displayName = 'UserAvatar';

  const {
    userName,
    additionalClassName
  } = props;

  const initialGenerator = (user) => {
    const nameStrings = user.split(' ');
    const initials = `${nameStrings[0].charAt(0)}${nameStrings[nameStrings.length - 1].charAt(0)}`;
    // These are capitalized through CSS
    return initials;
  };

  const classNames = additionalClassName ? `${avatarBadge} ${additionalClassName}` : avatarBadge;

  return (
    <div
      aria-label={userName}
      {...props.ariaProps}
      className={classNames}
      data-qa-selector="username_masthead"
      ref={ref}
    >
      <span aria-hidden="true">
        {initialGenerator(userName)}
      </span>
    </div>
  );
});

UserAvatar.propTypes = propTypes;
UserAvatar.defaultProps = {
  ariaProps: {}
};

export default UserAvatar;
